import SearchSalesResultsHeader from './SearchSalesResultsHeader';
export default SearchSalesResultsHeader;
